import { Reducer } from 'redux';

import { Backend } from '../../Backend/Backend';
import { minMaxDates } from '../../Utils/Time';
import { TypedStorage } from '../../Utils/TypedStorage';
import { EtudeType } from '../Elections/Types';
import { IMedia } from '../Search/Types';

import { CPermissionInitial, IUserActionTypes, IUserState } from './Types';

const initialUser = TypedStorage.get('userName', '');
const initialUserTS = TypedStorage.get('userDate', 0);
const initialUserToken = TypedStorage.get('userToken', '');
const initialPermissions = TypedStorage.get('permissions', CPermissionInitial);

let initialState: IUserState = {
    expires: new Date(0),
    token: '',
    username: '',
    permissions: initialPermissions,
    errorMessage: null,
    tokenPlayer: '',
    medias: [],
    allMediasID: [],
    allMediasSTR: [],
    user_id: 0,
    max_advancement_date: null,
    tokenExternal: null,
};

if ((initialUserToken !== '') && (initialUser !== '') && (initialUserTS !== 0)) {
    if (initialUserTS > Date.now()) {

        initialState = {
            ...initialState,
            expires: new Date(initialUserTS),
            token: initialUserToken,
            username: initialUser,
        };
        Backend.getInstance().setToken(initialUserToken);
    } else {

        TypedStorage.set('userName', '');
        TypedStorage.set('userDate', 0);
        TypedStorage.set('userToken', '');
        TypedStorage.set('medias', '');
    }
}

const reducer: Reducer<IUserState> = (state = initialState, action) => {
    switch (action.type) {
        case IUserActionTypes.LOGIN: {
            return {
                ...state,
                errorMessage: null
            };
        }
        case IUserActionTypes.LOGOUT: {
            TypedStorage.set('userName', '');
            TypedStorage.set('userToken', '');
            TypedStorage.set('userDate', 0);
            TypedStorage.set('etude', EtudeType.PLURALISME);
            TypedStorage.set('medias', "");
            return {
                ...state,
                expires: new Date(0),
                token: '',
                username: '',
                medias: [],
                allMediasID: [],
                allMediasSTR: [],
            };
        }
        case IUserActionTypes.LOGIN_ERROR: {
            TypedStorage.set('userName', '');
            TypedStorage.set('userToken', '');
            TypedStorage.set('userDate', 0);
            TypedStorage.set('medias', "");
            return {
                ...state,
                expires: new Date(0),
                token: '',
                username: '',
                errorMessage: action.payload
            };
        }
        case IUserActionTypes.LOGIN_SUCCESS: {
            TypedStorage.set('userName', action.payload[0]);
            TypedStorage.set('userToken', action.payload[1]);
            TypedStorage.set('userDate', action.payload[2]);
            if (action.payload[3].length > 0) {
                TypedStorage.set("medias", JSON.stringify(action.payload[3]));
            }
            let have_right_show_total = action.payload[5];
            TypedStorage.set("permissions", { 'show_total': have_right_show_total });

            return {
                ...state,
                expires: new Date(action.payload[2]),
                token: action.payload[1],
                username: action.payload[0],
                user_id: action.payload[4].id,
                permissions: { "show_total": have_right_show_total },
                errorMessage: null
            };
        }
        case IUserActionTypes.VERIFY_EXTERNAL_TOKEN_SUCCESS: {
            TypedStorage.set('userName', action.payload[0]);
            TypedStorage.set('userToken', action.payload[1]);
            TypedStorage.set('userDate', action.payload[2]);
            return {
                ...state,
                expires: new Date(action.payload[2]),
                token: action.payload[1],
                username: action.payload[0],
                user_id: action.payload[3].id,
                errorMessage: null
            };
        }
        case IUserActionTypes.GET_AUTHORIZED_MEDIAS: {
            return {
                ...state,
                isLoading: true
            };
        }
        case IUserActionTypes.GET_AUTHORIZED_MEDIAS_SUCCESS: {
            let medias = action.payload
            let formattedMedias: IMedia[] = medias.map((x: any) => {
                return {
                    id: x.media_id || x.id,
                    name: x.nomfiche || x.name,
                    advancement_date: x.advancement_date ? new Date(x.advancement_date) : new Date()
                }
            })
            let dates: Date[] = []
            medias.map(x => {
                if (x.advancement_date) {
                    dates.push(new Date(x.advancement_date))
                }
                return dates
            })
            let mediasID: number[] = medias.map((x: any) => {
                return x.media_id || x.id
            })
            let mediasStr: string[] = medias.map((x: any) => {
                return x.nomfiche || x.name
            })
            if (formattedMedias.length > 0) {
                TypedStorage.set("medias", JSON.stringify(formattedMedias));
            }
            return {
                ...state,
                medias: formattedMedias,
                max_advancement_date: dates.length > 0 ? minMaxDates(dates).maxDate : new Date(),
                allMediasID: mediasID,
                allMediasSTR: mediasStr,
                isLoading: false
            }
        }
        case IUserActionTypes.GET_TOKEN_PLAYER: {
            return {
                ...state,
                username: action.payload[2]
            }
        }
        case IUserActionTypes.GET_TOKEN_PLAYER_SUCCESS: {
            return {
                ...state,
                tokenPlayer: action.payload[1]
            }
        }
        case IUserActionTypes.SAVE_EXTERNAL_TOKEN: {

            TypedStorage.set('userName', '');
            return {
                ...state,
                tokenExternal: action.payload,
                username: ''
            }
        }
        default: {
            return state;
        }
    }
};

export { reducer as UserReducer };
